module.exports = __webpack_public_path__ + "static/media/motoboy_5.2b21d8bf.png";